'use strict';
const angular = require('angular');

export class workOrderShowComponent {
  /*@ngInject*/
  constructor(dialogs, CalendarEventService, $timeout) {
    this.dialogs = dialogs;
    this.CalendarEventService = CalendarEventService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.workOrder = this.resolve.config.workOrder;
    this.userHasPermission = this.resolve.config.userHasPermission;

    this.galleryImages = this.workOrder.attachments.filter(attachment => {
      return this.isImageMime(attachment.contentType);
    });

    this.galleryImages = this.galleryImages.map(function(obj){
      var rObj = {};

      rObj.title = obj.filename;
      rObj.alt = obj.filename;
      rObj.url = "/api/storage/" + obj._id;
      rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

      return rObj;
    });
  }

  countPdfAttachments(attachs) {
    return attachs.reduce((acc, obj) => {
      return acc + this.isPdfMime(obj.contentType);
    }, 0);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  ok() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.workOrderShow', [])
  .component('workOrderShow', {
    template: require('./workorder-show.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: workOrderShowComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/workorder-show/workorder-show.component.js